module.exports = "<h4>Add a Command</h4>\n<p>Commands are the basic mechanism by which changes are caused to happen in connected devices throughout your home. They can\n\tchange the state of a device in many ways, such as changing a light level, LED colors and so on. Use the lists below to\n\tselect the command that you wish to execute when this automation event is triggered.</p>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/advanced/codeitem-command/codeitem-command.component.html
// module id = 1511
// module chunks = 2